import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['tabs.component.scss']
})

export class TabsComponent implements OnInit {
  @Input() tabList: string[] = [];
  @Input() activeTab: string | null = null;
  @Output() changeTab = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit(): void {
  }

  setTab(tab: string): void {
    if (this.activeTab === tab) return;
    this.activeTab = tab;
    this.changeTab.emit(tab);
  }
}

